import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["accessibilityLabel", "id", "testID", "UNSAFE_svgProps"];
import React from 'react';
import Surface from '@bubble-ui/primitive-surface';
import Rect from '@bubble-ui/primitive-rect';
import Shape from '@bubble-ui/primitive-shape';
import withProvisionalOverrideFromContext from '@bubble-ui/hoc-with-provisional-override-from-context';
import { usePropsSpreadingDeprecationWarning } from '@bubble-ui/hook-use-props-spreading-deprecation-warning';
function PaymentLogoApplePay(_ref) {
  var {
      accessibilityLabel,
      id,
      testID,
      UNSAFE_svgProps
      /**
       * @deprecated props spreading is outdated and will be removed with v7.0.0
       */
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  usePropsSpreadingDeprecationWarning({
    componentName: 'PaymentLogoApplePay',
    props,
    useInstead: 'UNSAFE_svgProps',
    removalDate: 'v7.0.0'
  });
  return /*#__PURE__*/React.createElement(Surface, _extends({
    id: id
  }, testID ? {
    testID
  } : {}, UNSAFE_svgProps, {
    accessibilityLabel: accessibilityLabel,
    width: 35,
    height: 22,
    viewBox: "0 0 35 22"
  }, props), /*#__PURE__*/React.createElement(Rect, {
    fill: "#000000",
    x: "0",
    y: "0",
    width: "35",
    height: "22",
    rx: "2"
  }), /*#__PURE__*/React.createElement(Rect, {
    fill: "#FFFFFF",
    x: "1",
    y: "1",
    width: "33",
    height: "20",
    rx: "1"
  }), /*#__PURE__*/React.createElement(Shape, {
    d: "M10.1837,7.59548 C10.4748,7.23135 10.6724,6.74244 10.6203,6.24283 C10.1941,6.26402 9.67407,6.52398 9.373,6.88839 C9.10266,7.20045 8.86339,7.70984 8.92577,8.1885 C9.40415,8.23 9.88209,7.94939 10.1837,7.59548 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement(Shape, {
    d: "M10.6148,8.28189 C9.92012,8.24051 9.32944,8.67618 8.99767,8.67618 C8.66572,8.67618 8.15768,8.30275 7.60819,8.31281 C6.89299,8.32332 6.22937,8.72769 5.86644,9.37084 C5.11995,10.6575 5.66944,12.566 6.39536,13.6138 C6.74788,14.1323 7.17273,14.7031 7.73254,14.6826 C8.26147,14.6618 8.46878,14.3401 9.11171,14.3401 C9.75417,14.3401 9.94092,14.6826 10.5008,14.6722 C11.0814,14.6618 11.4444,14.1535 11.797,13.6346 C12.2014,13.0436 12.3669,12.473 12.3773,12.4417 C12.3669,12.4313 11.2577,12.0058 11.2474,10.7299 C11.237,9.66151 12.1183,9.15334 12.1598,9.12183 C11.6621,8.38574 10.8844,8.30275 10.6148,8.28189 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement(Shape, {
    d: "M16.664,6.83604 C18.174,6.83604 19.2254,7.87688 19.2254,9.39227 C19.2254,10.9131 18.1523,11.9593 16.6261,11.9593 L14.9543,11.9593 L14.9543,14.618 L13.7464,14.618 L13.7464,6.83604 L16.664,6.83604 L16.664,6.83604 Z M14.9543,10.9454 L16.3403,10.9454 C17.3919,10.9454 17.9905,10.3792 17.9905,9.39768 C17.9905,8.41623 17.3919,7.85535 16.3457,7.85535 L14.9543,7.85535 L14.9543,10.9454 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement(Shape, {
    d: "M19.5411,13.0055 C19.5411,12.0132 20.3015,11.4038 21.6498,11.3283 L23.2028,11.2367 L23.2028,10.7999 C23.2028,10.1689 22.7768,9.79138 22.0651,9.79138 C21.3908,9.79138 20.9701,10.1149 20.8678,10.6219 L19.7676,10.6219 C19.8323,9.59717 20.7059,8.84219 22.1081,8.84219 C23.4833,8.84219 24.3623,9.57023 24.3623,10.7081 L24.3623,14.618 L23.2459,14.618 L23.2459,13.685 L23.2191,13.685 C22.8902,14.316 22.1728,14.715 21.4286,14.715 C20.3177,14.715 19.5411,14.0247 19.5411,13.0055 Z M23.2028,12.4932 L23.2028,12.0456 L21.806,12.1319 C21.1103,12.1804 20.7167,12.4878 20.7167,12.9732 C20.7167,13.4693 21.1266,13.7929 21.7522,13.7929 C22.5664,13.7929 23.2028,13.232 23.2028,12.4932 Z",
    fill: "#000000"
  }), /*#__PURE__*/React.createElement(Shape, {
    d: "M25.4162,16.705 L25.4162,15.7613 C25.5023,15.7828 25.6964,15.7828 25.7936,15.7828 C26.3328,15.7828 26.6241,15.5563 26.8019,14.9739 C26.8019,14.9631 26.9045,14.6288 26.9045,14.6234 L24.8553,8.94463 L26.1171,8.94463 L27.5517,13.561 L27.5732,13.561 L29.0078,8.94463 L30.2374,8.94463 L28.1124,14.9145 C27.6272,16.2898 27.0664,16.732 25.8907,16.732 C25.7936,16.732 25.5023,16.7212 25.4162,16.705 Z",
    fill: "#000000"
  }));
}
PaymentLogoApplePay.displayName = 'PaymentLogoApplePay';
export default withProvisionalOverrideFromContext(PaymentLogoApplePay);
//# sourceMappingURL=index.js.map